<template>
  <div>
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="loading">
      <div class="content-right">
        <div class="top-btn">
          <DialogPop
            @confirm="rejectAll"
            @getRejectaccount="getRejectaccount"
            :marLeft="true"
            :isReject="true"
            isType="1"
            btnText="全部退回"
            centerText="是否确认全部退回？"
          ></DialogPop>
          <DialogPop
            @confirm="agreeAll"
            isType="0"
            btnText="全部通过"
            centerText="是否全部确认通过？"
          >
          </DialogPop>
        </div>
        <div class="card-box">
          <div class="card" v-for="item in cardData" :key="item.activityPocId">
            <!-- <div class="left">
                                <img v-if="fasle" src="" alt="">
                            </div> -->
            <div v-if="isMultiPoc(item) == '0' || isMultiPoc(item) == '1'" class="card-single is-hover-shadow">
              <div class="single-top" v-if="isMultiPoc(item) == '1'">
                <div class="single-top-left">{{ item.gpActivityPocDTOList[0].pocName }}</div>
                <div class="single-top-right">待审批</div>
              </div>
              <div class="single-top" v-else>
                <div class="single-top-left">
                  <span style="color: #cd1231">活动地点：</span>
                  <span>{{item.blockName}}</span>
                </div>
                <div class="single-top-right">待审批</div>
              </div>
              <div class="single-second" v-if="item.gpActivityPocDTOList !== null">
                <div class="single-second-left">
                  {{ item.gpActivityPocDTOList[0].contactPerson || '暂无' }} - {{ item.gpActivityPocDTOList[0].contactPhone || '暂无'}}
                </div>
                <div class="single-second-right">
                  <!-- <span>{{ item.gpActivityPocDTOList[0].provinceName }}</span>
                  <span>-</span> -->
                  <span>{{ item.gpActivityPocDTOList[0].pocAddress }}</span>
                </div>
              </div>
              <div class="single-second" v-else>
                <div class="single-second-left">
                  {{'暂无' }} - {{'暂无'}}
                </div>
                <div class="single-second-right">
                  <span>{{ item.blockAddress }}</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="single-third">
                <div class="single-third-left">
                  <!-- <span>活动渠道：{{ item.themeChannelCode + '-' + item.themeChannelName }}</span>
                  <span>活动渠道：{{ item.themeChannelName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span>活动形式：{{ item.themeStyleName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span v-if="item.themeLevelCode">活动级别：{{ item.themeLevelCode + '-' + item.themeLevelName }}</span> -->
                  <span>活动渠道：{{ item.themeChannelName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span>活动形式：{{ item.themeStyleName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span v-if="item.themeLevelCode">活动级别：{{ item.themeLevelName }}</span>
                </div>
                <div class="single-third-right">
                  <div class="single-button" @click="goApprove(item)">去审批</div>
                </div>
              </div>
            </div>
            <div v-else class="card-many is-hover-shadow">
              <div class="many-top">
                <div class="many-top-left">
                  <span style="color: #cd1231">街区名称：</span
                  ><span>{{ item.blockName }}</span>
                </div>
                <div class="many-top-right">待审批</div>
              </div>
              <div
                class="line"
                style="margin-top: 5px; margin-bottom: 15px"
              ></div>
              <div v-for="(poc,index) in item.gpActivityPocDTOList" :key="index">
                <div class="many-second">
                  <div class="many-second-title">
                    <span>{{ poc.pocName }}</span>
                  </div>
                  <div class="many-second-main">
                    <div class="many-second-left">
                      {{ poc.contactPerson || '暂无' }} - {{ poc.contactPhone || '暂无'}}
                    </div>
                    <div class="many-second-right">
                      <!-- <span>{{ poc.provinceName }}</span>
                      <span>-</span> -->
                      <span>{{ poc.pocAddress }}</span>
                    </div>
                  </div>
                </div>
                <div class="line"></div>
              </div>
              <div class="many-third">
                <div class="many-third-left">
                  <!-- <span>活动渠道：{{ item.themeChannelCode + '-' + item.themeChannelName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span>活动形式：{{ item.themeStyleCode + '-' + item.themeStyleName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span v-if="item.themeLevelCode">活动级别：{{ item.themeLevelCode + '-' + item.themeLevelName }}</span> -->
                  <span>活动渠道：{{ item.themeChannelName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span>活动形式：{{ item.themeStyleName }}</span>
                  <span style="margin: 0px 5px">|</span>
                  <span v-if="item.themeLevelCode">活动级别：{{ item.themeLevelName }}</span>
                </div>
                <div class="many-third-right">
                  <div class="many-button" @click="goApprove(item)">去审批</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="cardData.length == 0">
          <!-- style="height: 50px; line-height: 50px; text-align: center" -->
          <!-- 当前没有需要审批的活动场次 -->
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div v-if="cardData.length > 0" class="pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="queryParams.total"
            :current-page="queryParams.page"
            :page-size="queryParams.pageSize"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script language="JavaScript">
import { mapGetters } from "vuex";
import ContentHeader from "@/components/content-header";
import gameplanApi from "../../api/gameplan";
import DialogPop from './components/dialog-pop.vue'
export default {
  name: "activityPhoto-salePlace",
  components: {
    ContentHeader,
    DialogPop
  },
  data() {
    return {
      queryParams: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      cardData: [],
      themeId: '',
      themeDetailId: '',
      activityId: "",
      loading: false,
      rejectAccount: ''
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    gameplanLevel () {
      if (!this.userInfo) {
        return ''
      }
      const empLevel = this.userInfo.employeeLevel || 0

      if (empLevel === 90 || empLevel === 100) {
        return 'hq'
      }
      if (empLevel === 60 || empLevel === 70 || empLevel === 80) {
        return 'bu'
      }
      if (empLevel === 45 || empLevel === 50) {
        return 'region'
      }
      return ''
    },
  },
  watch: {},
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.themeId = this.$route.query.themeId
      this.themeDetailId = this.$route.query.themeDetailId
      this.getActivitylist();
    },
    // 理由
    getRejectaccount (val) {
      this.rejectAccount = val
    },
    getActivitylist() {
      this.loading = true
      let params = {
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        themeId: this.themeId,
        themeDetailId: this.themeDetailId
      };
      gameplanApi.getActivityNeedApprovePhoto(params).then((res) => {
        if (res.data.resultCode === "0") {
          this.loading = false
          let pageData = res.data.resultData.pageInfo;
          this.queryParams.total = Number(pageData.totalCounts);
          let cardData = res.data.resultData.activityList || [];
          this.cardData = cardData;
        } else {
          this.loading = false
          console.log("接口error");
        }
      });
    },
    isMultiPoc(activity) {
      // console.log(activity,'activity-isMultiPoc-1111');
      return activity.gpThemeDetailDTO.pocRelateType
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getActivitylist();
    },
    // 去审批
    goApprove(item) {
      this.$router.push({
        path: "/gameplan/activityPhoto-salePlace-detail",
        query: { activityId: item.activityId },
      });
    },
    rejectAll () {
      let arr = []
      for (let item1 of this.cardData) {
        for (let item of item1.imageApprovalList) {
          if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
            arr.push({
              "imageApprovalId": item.imageApprovalId,   
              "processAction": "03",
              'rejectReason':this.rejectAccount,
              'rejectPerson':this.userInfo.clientName,
            })
          }
        }
      }
      // console.log(arr,'arr-rejectAll');
      this.allApprove(arr)
    },
    agreeAll () {
      let arr = []
      for (let item1 of this.cardData) {
        for (let item of item1.imageApprovalList) {
          if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
            arr.push({
            "imageApprovalId": item.imageApprovalId,   
            "processAction": "02" 
            })
          }
        }
      }
      // console.log(arr,'arr-agreeAll');
      this.allApprove(arr)
    },
    allApprove (params) {
      this.loading = true
      gameplanApi.submitImageApproval(params).then((res) => {
        this.loading = false
        if (res.data.resultCode === "0") {
          if (params[0].processAction == "02") {
            this.$message.success("全部通过成功");
          } else if (params[0].processAction == "03") {
            this.$message.success("全部退回成功");
          }
          this.$router.go(-1)
        } else {
          console.log("error")
        }
      }).catch((err) => {
        this.loading = false
      })

    }
  },
};
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  .content-right {
    height: 100%;
    box-sizing: border-box;
    .top-btn {
      padding: 10px 10px;
      width: 916px;
      margin: 0 auto;
      height: 30px;
      line-height: 30px;
      // background-color: #101010;
      display: flex;
      justify-content: flex-end;

    }
    .card-box {
      margin: 0 auto;

      .card-single {
        padding: 10px 10px;
        width: 916px;
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 14px;
        margin-bottom: 20px;
        .single-top {
          display: flex;
          line-height: 34px;
          .single-top-left {
            font-size: 18px;
            font-weight: 600;
            color: #101010;
          }
          .single-top-right {
            flex: 1;
            text-align: right;
            font-size: 16px;
            font-weight: 600;
            color: #cd1231;
          }
        }
        .single-second {
          display: flex;
          line-height: 23px;
          .single-second-left {
            font-size: 14px;
            color: #999999;
          }
          .single-second-right {
            flex: 1;
            text-align: right;
            font-size: 14px;
            color: #999999;
          }
        }
        .single-third {
          display: flex;
          line-height: 23px;
          .single-third-left {
            flex: 1;
            font-size: 14px;
            color: #999999;
          }
          .single-third-right {
            justify-content: flex-end;
            height: 28px;
            line-height: 28px;
            .single-button {
              width: 80px;
              border-radius: 4px;
              background-color: #cd1231;
              color: #ffffff;
              font-size: 12px;
              text-align: center;
              padding: 1px 5px;
              margin-top: -3.5px;
              cursor: pointer;
            }
          }
        }
        .line {
          height: 1px;
          border-bottom: 1px solid #eeeeee;
          margin-top: 14px;
          margin-bottom: 14px;
        }
        .left {
          width: 110px;
          height: 110px;
          border-radius: 8px;
        }
        .center {
          text-align: left;
          margin-left: 17px;
          .center-top {
            height: 34px;
            line-height: 34px;
            font-size: 20px;
            // font-weight: 600;
            color: #101010;
            font-family: SourceHanSansSC-medium;
          }
          .center-main {
            height: 23px;
            line-height: 23px;
            font-size: 14px;
            color: #999999;
            margin-bottom: 14px;
            margin-top: 3px;
          }
          .center-bottom {
            display: flex;
            height: 32px;
            line-height: 32px;
            .center-bottom-left {
              font-size: 16px;
              color: #101010;
              margin-right: 15px;
            }
            .center-bottom-right {
              height: 20px;
              line-height: 20px;
              border-radius: 4px;
              background-color: #ffffff;
              color: #cd1231;
              font-size: 12px;
              text-align: center;
              font-family: Microsoft Yahei;
              border: 1px solid #cd1231;
              padding: 1px 5px;
              margin-top: 4px;
            }
          }
        }
        .right {
          flex: 1;
          text-align: right;
          .right-top {
            font-size: 16px;
            font-family: SourceHanSansSC-medium;
            color: #cd1231;
          }
          .right-main {
            height: 55px;
            line-height: 55px;
            font-size: 14px;
            color: #101010;
          }
          .right-bottom {
            display: flex;
            .empty {
              flex: 1;
            }
            .button {
              width: 100px;
              height: 30px;
              line-height: 30px;
              border-radius: 4px;
              background-color: #ffffff;
              color: #cd1231;
              font-size: 14px;
              text-align: center;
              font-family: Microsoft Yahei;
              border: 1px solid #cd1231;
              cursor: pointer;
            }
          }
        }
      }
      .card-many {
        padding: 10px 10px;
        width: 916px;
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 14px;
        margin-bottom: 20px;
        .many-top {
          display: flex;
          line-height: 34px;
          .many-top-left {
            font-size: 16px;
            font-weight: 600;
            color: #101010;
            font-family: SourceHanSansSC-medium;
          }
          .many-top-right {
            flex: 1;
            text-align: right;
            font-size: 16px;
            font-weight: 600;
            font-family: SourceHanSansSC-medium;
            color: #cd1231;
          }
        }
        .many-second {
          .many-second-title {
            line-height: 30px;
            font-size: 18px;
            font-weight: 600;
            color: #101010;
            margin-bottom: 5px;
          }
          .many-second-main {
            display: flex;
            line-height: 23px;
            .many-second-left {
              font-size: 14px;
              color: #999999;
            }
            .many-second-right {
              flex: 1;
              text-align: right;
              font-size: 14px;
              color: #999999;
            }
          }
        }
        .many-third {
          display: flex;
          line-height: 30px;
          .many-third-left {
            flex: 1;
            font-size: 14px;
            color: #999999;
          }
          .many-third-right {
            justify-content: flex-end;
            height: 28px;
            line-height: 28px;
            .many-button {
              width: 80px;
              border-radius: 4px;
              background-color: #cd1231;
              color: #ffffff;
              font-size: 12px;
              text-align: center;
              padding: 1px 5px;
              cursor: pointer;
            }
          }
        }
        .line {
          height: 1px;
          border-bottom: 1px solid #eeeeee;
          margin-top: 14px;
          margin-bottom: 14px;
        }
      }
    }
    .pagination {
      position: relative;
      text-align: center;
      bottom: 0;
    }
  }
  .content-left {
    padding-right: $content-middle;
  }
}
</style>
